import { saveAs } from 'file-saver';
import { parse } from 'json2csv';
import moment from 'moment';

import { downloadCsv } from '../../../queries/api/packaging-flow';

interface CsvParams {
    page: number;
    pageSize: number;
    differenceReported: boolean;
    packageIds: string[];
    status: string[];
    storeIds: string[];
    supplierIds: string[];
    parcPalettIds: string[];
    warehouseIds: string[];
    litigeStatus: string[];
    bonDeTransport?: string[];
    invoiceName?: string;
}

export const downloadCsvFile = async (params: CsvParams) => {
    try {
        const response = await downloadCsv(params);

        // Add 'Numéro lot facturation': show invoice name only when the flow has an
        // invoiceId AND the specific package row is invoiceable.
        const rows = Array.isArray(response) ? response : (response as any)?.items ?? [];
        const transformed = rows.map((row: any) => {
            const { invoiceName, invoiceId, isInvoiceable, ...rest } = row;
            return {
                ...rest,
                'Numéro lot facturation': invoiceId && isInvoiceable ? invoiceName ?? '' : '',
            };
        });

        const csv = parse(transformed, { delimiter: ';', quote: '' });
        const encoder = new TextEncoder();
        // Add BOM to the beginning of the CSV
        const bom = '\uFEFF';
        const encodedCsv = encoder.encode(bom + csv);

        const blob = new Blob([encodedCsv], { type: 'text/csv;charset=utf-8;' });

        const currentDate = new Date();
        const formattedDate = moment(currentDate).format('DD-MM-YYYY-HH:mm');

        saveAs(blob, `Flux d emballage - Export (${formattedDate}).csv`);
    } catch (error) {
        console.error('Error fetching or converting data:', error);
    }
};
